import * as yup from 'yup';

export const expenseFormSchema = yup.object().shape({
  incomplete: yup.boolean(),
  date: yup.string(),
  analyst: yup.string(),
  jobOrder: yup.string(),
  miscDescription: yup.string(),
});
